<template>
  <b-modal
    v-model="show"
    centered
    size="md"
    @show="onShow"
    @hidden="onHidden"
    @ok="onOk"
  >
    <template #modal-title>
      <h3 class="font-weight-bold">Select Services</h3>
    </template>

    <div v-if="isLoading" class="text-center py-5">
      <digger-loader />
    </div>
    <b-row v-if="!isLoading">
      <b-col>
        <b-form-input
          v-model.lazy="searchQuery"
          placeholder="Type to search services"
          @input="onSearchQueryChange"
          class="mb-2"
          autofocus
          clearable
        />
        <div class="text-danger" style="height: 32px">
          <span v-if="isMaxReached">
            You can only select up to 3 options.
          </span>
        </div>
      </b-col>
    </b-row>
    <b-row v-if="!isLoading" class="overflow-auto" style="height: 480px">
      <b-col>
        <div v-for="companyService in companyServices" :key="companyService.id">
          <!-- prettier-ignore -->
          <b-form-group v-if="searchQuery === '' || companyService.name.toLowerCase().includes(searchQuery.toLowerCase()) || pickedCompanyServiceIds.includes(companyService.id)">
              <b-form-checkbox v-model="pickedCompanyServiceIds" :value="companyService.id" :checked="isChecked(companyService.id)" @change="onCheckChange()">
                {{ companyService.name }}
              </b-form-checkbox>
            </b-form-group>
        </div>
      </b-col>
    </b-row>
  </b-modal>
</template>

<script>
import { mapActions, mapState } from 'vuex'

export default {
  name: 'CompanyServicesPickerModal',

  props: {
    showModal: {
      type: Boolean,
      default: false,
    },

    existingCompanyServices: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      isLoading: false,
      pickedCompanyServiceIds: [],
      searchQuery: '',
      isMaxReached: false,
      enterKeyHandler: null,
    }
  },

  computed: {
    ...mapState({
      companyServices: (state) => state.company.companyServices,
    }),

    show: {
      get() {
        return this.showModal
      },
      set() {
        this.resetData()
        this.$emit('onCloseCompanyServicesPickerModal')
      },
    },
  },

  methods: {
    ...mapActions({
      getPickerValues: 'company/getCompanyServicePickerValues',
    }),

    async onShow() {
      this.enterKeyHandler = (e) => {
        if (e.key === 'Enter') {
          e.preventDefault()
          this.onOk()
        }
      }
      document.addEventListener('keydown', this.enterKeyHandler)
      // if (this.companyServices.length === 0) {
      this.isLoading = true

      try {
        await this.getPickerValues()
        this.resetData()
      } catch (e) {
        this.$bvToast.toast('Could not load services. Please try again.', {
          variant: 'danger',
          title: 'Error',
        })
      } finally {
        this.isLoading = false
      }
      // } else this.resetData()
    },

    onHidden() {
      if (this.enterKeyHandler) {
        document.removeEventListener('keydown', this.enterKeyHandler)
        this.enterKeyHandler = null
      }
    },

    // prettier-ignore
    sortCompanyServices() {
      // Sort companyService name, then by checked status
      this.companyServices.sort((a, b) => (a.name < b.name ? -1 : 1))
      this.companyServices.sort((a, b) => this.pickedCompanyServiceIds.includes(b.id) - this.pickedCompanyServiceIds.includes(a.id))
    },

    isChecked(id) {
      return this.pickedCompanyServiceIds.includes(id)
    },

    onSearchQueryChange() {
      this.sortCompanyServices()
    },

    onCheckChange() {
      this.isMaxReached = false

      if (this.pickedCompanyServiceIds.length > 3) {
        this.isMaxReached = true
        this.pickedCompanyServiceIds.pop()
      }
    },

    onOk() {
      this.$emit('onCompanyServicesPicked', {
        companyServices: this.companyServices
          .sort((a, b) => (a.name < b.name ? -1 : 1))
          .filter((companyService) =>
            this.pickedCompanyServiceIds.includes(companyService.id),
          )
          .map((companyService) => companyService.name)
          .join(', '),
      })
    },

    resetData() {
      // Generate picked companyService ids
      this.pickedCompanyServiceIds = this.existingCompanyServices
        ? this.existingCompanyServices
            .split(',')
            .map((companyServiceName) => {
              // prettier-ignore
              const companyService = this.companyServices.find((t) => t.name.trim() === companyServiceName.trim())
              return companyService ? companyService.id : null
            })
            .filter((id) => id !== null)
        : []

      this.sortCompanyServices()
      this.searchQuery = ''
      this.isMaxReached = false
    },
  },
}
</script>
